import { render, staticRenderFns } from "./PaidOnlyNotice.vue?vue&type=template&id=3c77417a&scoped=true&"
import script from "./PaidOnlyNotice.vue?vue&type=script&lang=js&"
export * from "./PaidOnlyNotice.vue?vue&type=script&lang=js&"
import style0 from "./PaidOnlyNotice.vue?vue&type=style&index=0&id=3c77417a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c77417a",
  null
  
)

export default component.exports